module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDDING")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELLES")]), _vm._v(". Copyright © 2008 by Haywood Smith. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright5"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright5"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Smith, Haywood, 1949-")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Wedding belles / Haywood Smith.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("    p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN-13: 978-0-312-32973-0")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN-10: 0-312-32973-3")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("1. Middle-aged women—Fiction. 2. Female friendship—Fiction. 3. Mothers and daughters—Fiction. 4. Georgia—Fiction. 5. Domestic fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("PS3569.M53728W43 2008")]), _vm._v(" "), _c('p', {
    staticClass: "copyright4"
  }, [_vm._v("813’.54—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightr"
  }, [_vm._v("2008020997")]), _vm._v(" "), _c('p', {
    staticClass: "copyright5"
  }, [_vm._v("First Edition: September 2008")]), _vm._v(" "), _c('p', {
    staticClass: "copyright5"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987f7f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 69
// module chunks = 0